import { render, staticRenderFns } from "./lightLesson.vue?vue&type=template&id=14f1d50c&scoped=true"
import script from "./lightLesson.vue?vue&type=script&lang=js"
export * from "./lightLesson.vue?vue&type=script&lang=js"
import style0 from "./lightLesson.vue?vue&type=style&index=0&id=14f1d50c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f1d50c",
  null
  
)

export default component.exports